import React from "react";
import { Helmet } from "react-helmet";
import { graphql, useStaticQuery } from "gatsby";
import { getSrc, ImageDataLike } from "gatsby-plugin-image";
import { FaviconQuery } from "../../graphql-types";

const query = graphql`
  query Favicon {
    home {
      brand {
        touchIcon: logo {
          file {
            fileLocal {
              childImageSharp {
                gatsbyImageData(
                  width: 180
                  height: 180
                  formats: [PNG]
                  transformOptions: { fit: FILL }
                )
              }
            }
          }
        }
        favicon {
          file {
            fileLocal {
              publicURL
            }
          }
        }
        logo {
          file {
            fileLocal {
              childImageSharp {
                gatsbyImageData(
                  width: 16
                  height: 16
                  transformOptions: { fit: FILL }
                )
              }
            }
          }
        }
      }
    }
  }
`;

export default function Favicon() {
  const data = useStaticQuery<FaviconQuery>(query);
  if (!data.home) {
    throw new Error("Could not query home node");
  }

  const { favicon, logo, touchIcon } = data.home.brand;
  const icon =
    favicon?.file?.fileLocal?.publicURL ||
    getSrc(logo.file?.fileLocal as ImageDataLike);

  return (
    <Helmet>
      <link rel="icon" href={icon} />
      <link
        rel="apple-touch-icon"
        href={getSrc(touchIcon?.file?.fileLocal as ImageDataLike)}
      />
    </Helmet>
  );
}
